import { render, staticRenderFns } from "./transactionStatistics.vue?vue&type=template&id=d66e8cd6"
import script from "./transactionStatistics.vue?vue&type=script&lang=js"
export * from "./transactionStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports